export default function removeMultipleNodes(setNodes, nodes, nodeArr) {
  const filteredNodes = nodes.filter((item) => {
    if (!nodeArr.includes(item.id)) return item;
  });
  setNodes(filteredNodes);
}
